import { AidaDescription_eng } from 'entities/application/constants/applications/AIDA/Aida_Description';
import { AidaInstruction_eng } from 'entities/application/constants/applications/AIDA/AidaInstruction';
import { AidaPlans_eng } from 'entities/application/constants/applications/AIDA/AidaPlans';
import { ApplicationWithDetails } from '../../../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Aida_eng: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EBD11`,
	// eslint-disable-next-line sonarjs/no-duplicate-string
	name: `Aida`,
	description: `A team of experienced managers, analysts and developers for a remote solution daily tasks in your pocket.`,
	descriptionHTML: AidaDescription_eng,
	descriptionCard: `A team of experienced managers in your pocket.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/aida/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/aida/bgr`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-1-new-en`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-2-new-en`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-3-new-en`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-4-new-en`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: `https://uk-vkus.ru/`,
	supportUrl: null,
	redirectUrl: encodeURI(
		`https://auth.dodois.io/connect/authorize?client_id=alekseykharlanov8-q96izv0yyp&scope=staffmembers:read stopsales deliverystatistics staffshifts:read productionefficiency accounting user.role:read offline_access&response_type=code&redirect_uri=https://dodovkus.ru/callback/&code_challenge=dhV1gXYqv1bN4rKJ0ISUwFkLTpF94tMXvQkXpSrvUO8&code_challenge_method=S256`,
	),
	contactEmail: `Telegram channel`,
	supportEmail: `https://t.me/+TSY5w7zNctg4NzBi`,
	categories: [`Notifications`, `Production monitoring`, `Feedback`, `Customers`],
	countries: [`All`],
	languages: [`Русский`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	price: `Free`,
	version: `1.0`,
	type: `Bot`,
	developer: `УК Вкус`,
	plans: AidaPlans_eng,
	instructions: AidaInstruction_eng,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: false,
	versionHistory: `https://aidaupdate.kaiten.site`,
	goToApp: true,
};
